import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll to top on route change. React Router doesn't do this by default
// (it preserves SPA scroll position), which is fine for back-button but
// awful for footer-link navigation.
//
// Skip when the URL has a hash (those are explicit anchor jumps) or when
// only query params changed (e.g. filter tweaks on /search).
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
}
